import React from 'react';
import styled from 'styled-components';
import { formatPrice } from '@lemonadefashion/money';
import { CashPayoutSummaryLine } from './history_row';
import { useTokenTranslate } from '../../contexts/token_translation_context';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const BalanceSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BalanceLabel = styled.span`
  font-size: 13px;
  color: #888;
  margin-bottom: 4px;
`;

const BalanceAmount = styled.span`
  font-size: 72px;
  font-weight: 700;
  color: #2a1a6e;
  line-height: 1.1;
`;

const Divider = styled.div`
  border-bottom: 1px dashed #ddd;
  margin: 4px 0 12px;
`;

const SummaryHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 6px;
`;

const SummaryTitle = styled.h4`
  font-size: 20px;
  font-weight: 600;
  color: #666;
  margin: 0;
`;

const SeeAllLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #A6C857;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  &:hover { text-decoration: underline; }
`;

const SummaryList = styled.div`
  overflow-y: auto;
  max-height: 90px;
  padding-right: 8px;
`;

const EmptyText = styled.p`
  font-size: 13px;
  color: #aaa;
  margin: 8px 0;
`;

const ArrowRight = () => (
  <svg width='13' height='13' viewBox='0 0 24 24' fill='none'>
    <path d='M5 12h14M13 5l7 7-7 7' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

const CashPayoutContent = ({ balance, currency, summaryData, onCheckAllPayouts }) => {
  const { translate } = useTokenTranslate();
  return (
  <Wrap>
    <BalanceSection>
      <BalanceLabel>{translate('web.wallet_modal.cash_balance_text')}</BalanceLabel>
      <BalanceAmount>{formatPrice({ amount: balance, currency })}</BalanceAmount>
    </BalanceSection>

    <Divider />

    <SummaryHead>
      <SummaryTitle>{translate('web.cash_payout_content.summary_title')}</SummaryTitle>
      {summaryData && summaryData.length > 0 && (
        <SeeAllLink onClick={onCheckAllPayouts}>
          {translate('web.cash_payout_content.check_all_payouts_button')} <ArrowRight />
        </SeeAllLink>
      )}
    </SummaryHead>

    <SummaryList>
      {summaryData && summaryData.length > 0
        ? summaryData.map(item => (
          <CashPayoutSummaryLine key={item.id}
            amount={item.amount}
            currency={item.currency}
            dateCreated={item.date_created} />
        ))
        : <EmptyText>{translate('web.cash_payout_content.no_payouts_text')}</EmptyText>}
    </SummaryList>
  </Wrap>
  );
};

export default CashPayoutContent;
